import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id DDE4A6E4-BDE8-4E63-8F77-E3D06BF29BF1
 * name keyboard-f7
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-f7.svg
 * tags
 */
export const KeyboardF7Icon = createSvgIcon(<><path d="M5 7H11V9H7V11H10V13H7V17H5V7M15 17H13L17 9H13V7H19V9L15 17Z" /></>, 'KeyboardF7Icon');
export default KeyboardF7Icon